import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

interface RootProps {
    subKind?: "numbers";
    indent?: number;
    empty?: boolean;
    number?: boolean;
    horizontalAlign?: "center" | "left" | "right";
}

export const Root = styled.td<RootProps>(
    props => ({
        color: theme(props).tables.headers.smallFont.color,
    }),
    props =>
        props.subKind !== "numbers" && {
            ...theme(props).tables.headers.smallFont.css(),
            padding: "10px 5px",
            letterSpacing: "0.005em",
            verticalAlign: "bottom",
            textAlign: props.horizontalAlign,
        },
    props =>
        props.number && {
            textAlign: props.horizontalAlign ?? "center",
        },
    props =>
        props.empty && {
            textAlign: props.horizontalAlign ?? "center",
            lineHeight: "30px",
        },
    props => props.indent != undefined && isFinite(props.indent) && { paddingLeft: 12 + props.indent * 12 }
);
